import { EFacility } from '../../../../api-models/common/json_query';
import { createTermTagManager } from '../../utils/createTermTagManager';

export const bathFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'bath',
  label: 'С ванной',
  id: EFacility.Bath,
});

export const conditionerFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'conditioner',
  label: 'С кондиционером',
  id: EFacility.Conditioner,
});

export const dishWasherFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'dish_washer',
  label: 'С посудомоечной машиной',
  id: EFacility.Dishwasher,
});

export const fridgeFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'has_fridge',
  label: 'С холодильником',
  id: EFacility.Fridge,
});

export const garageFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'garage',
  label: 'С гаражом',
  id: EFacility.Garage,
});

export const internetFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'internet',
  label: 'С интернетом',
  id: EFacility.Internet,
});

export const kidsAllowedFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'kids',
  label: 'Можно с детьми',
  id: EFacility.KidsAllowed,
});

export const kitchenFurnitureFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'has_kitchen_furniture',
  label: 'С кухонной мебелью',
  id: EFacility.KitchenFurniture,
});

export const petsAllowedFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'pets',
  label: 'Можно с животными',
  id: EFacility.PetsAllowed,
});

export const phoneFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'phone',
  label: 'С телефоном',
  id: EFacility.Phone,
});

export const poolFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'pool',
  label: 'С бассейном',
  id: EFacility.Pool,
});

export const saunaFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'bathhouse',
  label: 'С баней',
  id: EFacility.Sauna,
});

export const securityFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'security',
  label: 'С охраной',
  id: EFacility.Security,
});

export const showerFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'shower',
  label: 'С душевой кабиной',
  id: EFacility.Shower,
});

export const tvFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'tv',
  label: 'С телевизором',
  id: EFacility.TV,
});

export const washerFacilityTagManager = createTermTagManager({
  jsonQueryKey: 'has_washer',
  label: 'Со стиральной машиной',
  id: EFacility.Washer,
});
